import React from "react";
import { FIELD_NOTES } from "@/data/content";
import { CompassMark } from "@/components/CompassMark";

export const FieldNotesStrip = () => {
  // Duplicate for seamless loop
  const items = [...FIELD_NOTES, ...FIELD_NOTES];

  return (
    <section
      data-testid="home-field-notes-strip"
      className="relative bg-ink-surface border-y border-ink-line py-8 overflow-hidden"
      aria-label="Field notes"
    >
      <div className="container-edge mb-4 flex items-center justify-between">
        <p className="eyebrow">Field Notes</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">Live · Capture → Refine</p>
      </div>
      <div
        className="relative w-full overflow-hidden"
        style={{ maskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)", WebkitMaskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)" }}
      >
        <div className="flex whitespace-nowrap items-center gap-12 animate-marquee will-change-transform" style={{ width: "max-content" }}>
          {items.map((note, i) => (
            <div key={`${note.slug}-${i}`} className="flex items-center gap-12 shrink-0">
              <span className="font-serif italic text-paper-primary text-base md:text-lg">
                {note.text}
              </span>
              <CompassMark size={14} opacity={0.4} alt="" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FieldNotesStrip;
